export const POSES = {
  base: '/briefy/base.png',
  blink: '/briefy/blink.png',
  wave: '/briefy/wave.png',
  wave2: '/briefy/wave2.png',
  curious: '/briefy/curious.png',
  thinking: '/briefy/thinking.png',
  sitting: '/briefy/sitting-supported-v2.png',
  sitting_blink: '/briefy/sitting-supported-blink-v2.png',
  happy: '/briefy/happy.png',
  surprised: '/briefy/surprised.png',
  resting: '/briefy/resting.png',
  pointing: '/briefy/pointing.png',
  explaining: '/briefy/explaining.png',
  walking: '/briefy/walking.png',
  peek: '/briefy/peek.png',
  peek_blink: '/briefy/peek_blink.png',
};

let preloaded = false;
export const preloadPoses = () => {
  if (preloaded) return;
  preloaded = true;
  Object.values(POSES).forEach((src) => {
    const img = new Image();
    img.src = src;
  });
};
